<template>
    <div>

        <div v-if="isEditor && isVisible" :style="style" style="width: 350px;"
             id="colorPickerElement" @mousedown="stopMousedownPropagation">

            <p style="margin-bottom: 15px">Order No.: {{order.orderNumber}}</p>

            <div style="float: left;">
                <Form :model="dispatchForm" ref="dispatchForm" :label-width="110">
                    <FormItem prop="finalQty" label="Final Qty">
                        <Input v-model="dispatchForm.finalQty"/>
                    </FormItem>
                    <FormItem prop="finalWt" label="Final Wt.">
                        <Input v-model="dispatchForm.finalWt"/>
                    </FormItem>
                    <FormItem prop="breakageQty" label="Breakage Qty">
                        <Input v-model="dispatchForm.breakageQty"/>
                    </FormItem>
                    <FormItem prop="breakageNote" label="Breakage Note">
                        <Input type="textarea" v-model="dispatchForm.breakageNote"/>
                    </FormItem>
                    <FormItem prop="missingQty" label="Missing Qty">
                        <Input v-model="dispatchForm.missingQty"/>
                    </FormItem>
                    <FormItem prop="missingNote" label="Missing Note">
                        <Input type="textarea" v-model="dispatchForm.missingNote"/>
                    </FormItem>
                    <div style="float: right">
                            <Button @click="onAddDispatchDetails(order.orderDetails.id, order.internalstatus, order.id,
                            order.orderDetails.dispactchVerification, order.materials)">
                                Save</Button>
                        <Button style="margin-left: 10px" @click="close()">Cancel</Button>
                    </div>
                </Form>
            </div>



        </div>

        <!--<div v-if="isRenderer" style="text-align: center;">-->
                <!--<p style="color: #999999;" v-if="$parent.$parent.$parent.orders[row]">-->
                    <!--{{$parent.$parent.$parent.orders[row].materials.type}}-->
                <!--</p>-->
                <!--<p>{{value}}</p>-->
        <!--</div>-->

    </div>
</template>

<script>
    import {BaseEditorComponent} from '@handsontable/vue'
    import {Constants} from "../../Constants/Constant"
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders"
    import moment from 'moment'

    export default {
        name: "QuantityPopup",
        extends: BaseEditorComponent,
        data:function () {
            return{
                Constants: Constants,
                order: null,
                hotInstance: null,
                TD: null,
                row: null,
                col: null,
                prop: null,
                originalValue: null,
                value: '',
                cellProperties: null,
                isVisible: false,
                isEditor: null,
                isRenderer: null,
                editorElement: null,
                style: {
                    position: "absolute",
                    padding: "15px",
                    background: "#fff",
                    zIndex: 999,
                    border: "1px solid #000",
                    left: "0px",
                    top: "0px"
                },
                loader1: false,
                dispatchForm: {
                    finalQty: '',
                    finalWt: 0,
                    breakageQty: 0,
                    breakageNote: 0,
                    missingQty: 0,
                    missingNote: 0,
                }
            }
        },
        methods:{
            stopMousedownPropagation: function(e) {
                e.stopPropagation();
            },
            prepare: function(row, col, prop, td, originalValue, cellProperties) {
                BaseEditorComponent.options.methods.prepare.call(this, row, col, prop, td, originalValue, cellProperties);
                const tdPosition = td.getBoundingClientRect();

                this.style.left = tdPosition.left + window.pageXOffset + 'px';
                this.style.top = tdPosition.top + window.pageYOffset + 'px';
            },
            open: function() {
                this.isVisible = true
                let screen = this.$parent.$parent.$parent.screen
                let ordersVariable = screen + '_orders'
                let pRow = this.hotInstance.toPhysicalRow(this.row)                             //When accessing original array
                this.order = this.$parent.$parent.$parent[ordersVariable][pRow]

                this.dispatchForm = { finalQty: '', finalWt: 0, breakageQty: 0,
                                      breakageNote: 0, missingQty: 0, missingNote: 0 }
            },
            focus: function() {
                this.isVisible = true;
            },
            close: function() {
                this.isVisible = false;
            },
            setValue: function(value) {
                this.value = value;
            },
            getValue: function() {
                return this.value;
            },
            onAddDispatchDetails(orderDetailId, internalStatusId, orderId, dispactchVerification, materials){
                let dv = []
                if(dispactchVerification && Object.prototype.toString.call(dispactchVerification) == '[object Array]'){
                    dv = dispactchVerification;
                }
                dv.unshift({
                    createdAt : moment().format('DD-MM-YYYY HH:MM:ss a'),
                    internalStatusId: internalStatusId,
                    finalQuantity: this.dispatchForm.finalQty,
                    finalWeight: this.dispatchForm.finalWt,
                    breakageQuantity: this.dispatchForm.breakageQty,
                    breakageNote: this.dispatchForm.breakageNote,
                    missingQuantity: this.dispatchForm.missingQty,
                    missingNote: this.dispatchForm.missingNote
                })

                this.updateRecord(orderDetailId, { dispactchVerification: dv }, 'orderDetails', 'loader1')

                if(this.dispatchForm.finalQty||this.dispatchForm.finalWt){
                    if(this.dispatchForm.finalQty){materials.boxes = this.dispatchForm.finalQty}
                    if(this.dispatchForm.finalWt){materials.kg = this.dispatchForm.finalWt}
                    this.updateRecord(orderId, {materials: materials}, 'orders', 'loader1')
                }
            },
            async updateRecord(id, obj, table, loaderStr){
                this[loaderStr] = true
                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: { id: id, obj: obj}
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!')
                    this[loaderStr] = false
                    this.close()
                    this.finishEditing()
                }
            },
        }
    }
</script>

<style scoped>

</style>
